<template>
  <div class="p-4">
    <h4>{{ chartRoute.title }}</h4>
    <p>Nearly 1,000 offshore companies established in dozens of jurisdictions around the world were linked to more than 330 politicians identified in the Pandora Papers.</p>
    <stacked-bar-chart
      :data="tsv"
      :fixed-height="fixedHeight"
      :social-mode="socialMode"
      :social-mode-ratio="0.5"
      hide-legend/>
    <p class="text-muted mt-2 small text-right">Source: Pandora Papers data</p>
  </div>
</template>

<script>
import chart from '../mixins/chart'

export default {
  mixins: [chart],
  name: 'ChartPoliticiansForEachJurisdiction',
  computed: {
    tsv () {
      return this.$options.tsv
    }
  }
}
</script>

<tsv>
label	value
British Virgin Islands	656
Panama	102
Cyprus	69
Seychelles	23
Singapore	20
</tsv>
